<template>
    <div class="layout">
        <div class="layout__header">
            <div class="layout__title">
                <h3>Auditoria de Unidades</h3>
            </div>
            <div class="layout__controls">
                <div class="form-inline">
                    <button @click="buscar" class="btn-info btn--bigger">
                        <i class="fa fa-search"></i><span>Consultar</span>
                    </button>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card__title">
                <h5>Filtros de la consulta</h5>
            </div>
            <div class="card__content">
                <div class="row">
                    <div class="col-xs-12 col-md-4">
                        <div class="form-field select">
                            <div class="select-field">
                                <select v-model="form.tipo_fecha" name="tipo_fecha" id="tipo_fecha">
                                    <option value="H">Hoy</option>
                                    <option value="A">Ayer</option>
                                    <option value="P">Personalizado</option>
                                </select>
                                <label for="tipo_fecha">
                                    Tipo de fecha
                                </label>
                            </div>
                        </div>
                    </div>
                    <div v-show="form.tipo_fecha === 'P'" class="col-xs-12 col-md-4">
                        <div class="form-field">
                            <div class="datepicker-field datepicker-field--stretch">
                                <date-picker
                                    @keyup.enter="buscar"
                                    stretch
                                    type="date"
                                    id="desde"
                                    v-model="form.desde"
                                ></date-picker>
                                <label>Desde</label>
                            </div>
                        </div>
                    </div>
                    <div v-show="form.tipo_fecha === 'P'" class="col-xs-12 col-md-4">
                        <div class="form-field">
                            <div class="datepicker-field datepicker-field--stretch">
                            <date-picker
                                @keyup.enter="buscar"
                                stretch
                                type="hasta"
                                id="hasta"
                                v-model="form.hasta"
                            ></date-picker>
                                <label>Hasta</label>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-4">
                        <div class="form-field">
                            <input-field @keyup.enter="buscar" placeholder="Escriba un número..." v-model="form.numero_contenedor" id="numero_contenedor">
                                # Contenedor
                            </input-field>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card__content">
                <div class="row">
                    <div class="col-xs-12">
                        <k-table 
                            noForms
                            :filterStatus="false"
                            :columns="[
                                {
                                    display : 'Fecha',
                                    value : 'fecha'
                                },
                                {
                                    display : 'Secuencia',
                                    value : 'secuencia'
                                },
                                {
                                    display : '# Contenedor',
                                    value : 'numero_contenedor'
                                },
                                {
                                    display : 'Cambios',
                                    value : 'cambios'
                                }
                            ]"
                            :params="form"
                            :path="path"
                            ref="auditoriaPropiedad"
                            :deleteButton="false" 
                            :createButton="false" 
                            :editButton="false"></k-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: function () {
        return {
            form: {
                tipo_fecha: 'H',
                desde: moment(new Date()).format('YYYY-MM-DD'),
                hasta: moment(new Date()).format('YYYY-MM-DD'),
                numero_contenedor: ''
            },
            path: url + '/auditoria-unidades'
        };
    },
    methods: {
        buscar: function () {
            this.$refs.auditoriaPropiedad.loadRows();
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/AuditoriaPropiedad.vue